import { render, staticRenderFns } from "./DeptModules.vue?vue&type=template&id=0d517033&scoped=true"
import script from "./DeptModules.vue?vue&type=script&lang=js"
export * from "./DeptModules.vue?vue&type=script&lang=js"
import style0 from "./DeptModules.vue?vue&type=style&index=0&id=0d517033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d517033",
  null
  
)

export default component.exports